<template>
    <div id="move-recurring-booking-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
        <div class="modal-dialog" >
            <div class="panel panel-color panel-inverse m-0">
                <div class="panel-heading">
                    <button type="button" class="close" @click.prevent="revertFunction(); hideModal()" aria-hidden="true">×</button>
                    <h3 class="panel-title truncate">
                        <i class="zmdi zmdi-arrow-right m-r-10"></i>
                        {{ trans('calendar.update_calendar_confirm_title') }}
                    </h3>
                </div>
            </div>

            <div class="modal-content" style="min-height:auto;">
                <div class="modal-body p-0">
                    <p>{{ trans('calendar.recurring_action_title') }}</p>

                    <p>{{ trans('calendar.recurring_action_move') }}</p>

                    <recurring-action-choices v-if="booking" type="move" :booking="booking" v-model="applyRecurringActionTo"></recurring-action-choices>

                    <div class="text-right">
                        <button class="btn btn-custom " @click.prevent="move( applyRecurringActionTo )">
                            <i class="zmdi zmdi-check m-r-5"></i>{{ trans('global.save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { http } from '../../http';
import RecurringActionChoices from './RecurringActionChoices';

export default {
    components: {
        RecurringActionChoices,
    },

    data() {
        return {
            booking: null,
            applyRecurringActionTo: 'this',
        }
    },

    mounted() {
        this.$event_bus.$on('showMoveRecurringBookingModal', ({ booking, revertFunction }) => {
            this.applyRecurringActionTo = 'this',
            this.booking = booking;
            this.revertFunction = revertFunction;

            $('#move-recurring-booking-modal').modal('show');
        });
    },

    methods: {
        hideModal() {
            this.booking = null;
            this.revertFunction = () => {};
            $('#move-recurring-booking-modal').modal('hide');
        },

        move(applyRecurringActionTo = 'this') {
            http.post(`/app/booking/${this.booking.id}/move`, {
                    start: this.booking.start.format('YYYY-MM-DD HH:mm:ss'),
                    end: this.booking.end.format('YYYY-MM-DD HH:mm:ss'),
                    apply_recurring_action_to: applyRecurringActionTo,
                })
                .then(({ data }) => {
                    this.hideModal();
                    toastr.success(data.success);

                    if (applyRecurringActionTo !== 'this') {
                        this.$event_bus.$emit('calendarReload');
                    }

                    this.$event_bus.$emit('refreshTaskList');
                    this.$event_bus.$emit('bookingTimeUpdated', this.booking);
                })
                .catch(error => {
                    this.revertFunction();
                    this.hideModal();

                    setTimeout(() => {
                        swal(trans('global.error_title'), trans('global.error'), 'warning');
                    }, 500)
                });
        }
    },
}
</script>
